module.exports = __webpack_public_path__ + "img/right-profile-arrow.b79fe934.svg";